import { get } from '../../../container';
import MEMBERS from '../../../api/query/Members';

export const GET_MEMBERS_FROM_SERVICE_LOADING = 'GET_MEMBERS_FROM_SERVICE_LOADING';
export const GET_MEMBERS_FROM_SERVICE_SUCCESS = 'GET_MEMBERS_FROM_SERVICE_SUCCESS';
export const GET_MEMBERS_FROM_SERVICE_FAILURE = 'GET_MEMBERS_FROM_SERVICE_FAILURE';

/**
 * @param {Object} service
 */
export function getMembersFromService(service) {
  return (dispatch) => {
    const serviceUuid = service.uuid;

    dispatch({ type: GET_MEMBERS_FROM_SERVICE_LOADING, payload: { service } });

    if (!serviceUuid) {
      dispatch({ type: GET_MEMBERS_FROM_SERVICE_SUCCESS, payload: { list: [] } });

      return;
    }

    get('graphql').query(MEMBERS, { serviceUuid }, ({ data }) => {
      const list = data.Members;

      dispatch({ type: GET_MEMBERS_FROM_SERVICE_SUCCESS, payload: { list } });
    }, (status) => dispatch({ type: GET_MEMBERS_FROM_SERVICE_FAILURE, payload: { status } }));
  };
}



// WEBPACK FOOTER //
// ./src/modules/members/actions/members.js